import * as React from 'react';
import { ArticleHeading1, ArticleHeading2, Body1, useDeviceType } from '@cian/ui-kit';

import { StickyActions } from '../../../StickyActions';

import * as styles from './styles.css';

export interface ICommunicationLayoutProps {
  image: React.ReactElement;
  title: string | React.ReactElement;
  action?: React.ReactElement;
  prependTitle?: React.ReactElement;
  message?: string | React.ReactElement;
  testId?: string;
}

export const CommunicationLayout: React.FC<React.PropsWithChildren<ICommunicationLayoutProps>> = props => {
  const { image, title, message, action, prependTitle, children, testId } = props;
  const isDesktop = useDeviceType() === 'desktop';
  const TitleComponent = isDesktop ? ArticleHeading1 : ArticleHeading2;

  return (
    <div className={styles['root']} data-testid={testId}>
      <div className={styles['content-wrapper']}>
        <div className={styles['image-area']}>{image}</div>
        {prependTitle && <div className={styles['prepend-title-area']}>{prependTitle}</div>}

        <div className={styles['title-area']}>
          <TitleComponent data-testid="communication-title">{title}</TitleComponent>
        </div>

        {message && (
          <div className={styles['message-area']}>
            <Body1 data-testid="communication-message" display="inline">
              {message}
            </Body1>
          </div>
        )}

        {children && <div className={styles['content-area']}>{children}</div>}
      </div>
      {action && (
        <StickyActions>
          <div className={styles['action-area']}>{action}</div>
        </StickyActions>
      )}
    </div>
  );
};

CommunicationLayout.displayName = 'CommunicationLayout';
